import React, { useEffect, useMemo, useRef, useState } from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import { useTranslation } from 'react-i18next';
import { debounce } from '@/common/utils/index';
import styles from '@/modules/admin-resellers/styles.less';
import ExportButton from '@/modules/admin-resellers/components/ExportButton';

const Filters = ({ search, sortBy, sortOrder, onSearchChange }) => {
  const { t } = useTranslation();
  const [searchInput, setSearchInput] = useState(search);
  const searchChangeRef = useRef(onSearchChange);

  useEffect(() => {
    searchChangeRef.current = onSearchChange;
  }, [onSearchChange]);

  const debouncedSearchChange = useMemo(
    () => debounce((value) => searchChangeRef.current(value), 300),
    []
  );

  useEffect(() => {
    setSearchInput(search);
  }, [search]);

  useEffect(() => {
    debouncedSearchChange(searchInput);
  }, [debouncedSearchChange, searchInput]);

  return (
    <div className={styles.controls}>
      <TextField
        value={searchInput}
        onChange={(event) => setSearchInput(event.target.value)}
        placeholder={t('Search by name, email, contact person or address')}
        variant="outlined"
        sx={{ width: '480px' }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
      <ExportButton search={search} sortBy={sortBy} sortOrder={sortOrder} />
    </div>
  );
};

export default Filters;
